import style from './TickerCell.module.css';

export const TickerCell = ({ label, value, visible }) => {
    const formattedValue = value < 10 ? `0${value}`: value.toString();

	if(!visible) {
		return (
			<span></span>
		);
	}
    return (
        <div className={ style.tickerCell }>
            <span className={ style.tickerCellValue }>{ formattedValue }</span>
            <span className={ style.tickerCellLabel }>{ label }</span>
        </div>
    );
}